import { Link } from '@blackbird/ui-base';
import { MailOutline, Phone } from '@mui/icons-material';
import { Card, CardContent, Grid, Theme, Typography } from '@mui/material';
import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { compose } from 'recompose';

import { WithStyles, withStyles } from '@/hocs/with-styles';

const styles = (theme: Theme) => ({});
interface Properties {}
interface State {}
class HelpPage extends React.Component<Properties & WithTranslation & WithStyles<typeof styles>, State> {
  render() {
    const { t, theme } = this.props;
    return (
      <Grid container direction="column">
        <Grid item xs={12} sm={12} md={12}>
          <Card elevation={1}>
            <CardContent>
              <Grid container direction="column">
                <Typography variant="h3">{t(['shared:help'], { defaultValue: 'Help' })}</Typography>

                <Typography variant="h5" style={{ marginTop: theme.spacing(3) }}>
                  1. {t(['shared:helpToSelfHelp'], { defaultValue: 'Help to self-help' })}
                </Typography>

                <Grid container>
                  <Typography>{t(['shared:helpCenterExplanation1'], { defaultValue: 'Check out our' })}</Typography>
                  <Typography
                    color="secondary"
                    style={{ marginLeft: theme.spacing(0.5), marginRight: theme.spacing(0.5) }}
                  >
                    <Link
                      href="https://www.notion.so/factbird/Help-Center-bcefd44b60cf42ec88e87b8296c824ff"
                      target="_blank"
                    >
                      {t(['shared:helpCenter'], { defaultValue: 'Help Center' })}
                    </Link>
                  </Typography>
                  <Typography>
                    {t(['shared:helpCenterExplanation2'], {
                      defaultValue: 'with documentation of features and tips for using the Factbird system',
                    })}
                    .
                  </Typography>
                </Grid>

                <Typography variant="h5" style={{ marginTop: theme.spacing(3) }}>
                  2. {t(['shared:stillHaveMoreQuestions'], { defaultValue: 'Still have more questions?' })}
                </Typography>
                <Typography>
                  {t(['shared:contactOurSupport'], {
                    defaultValue: 'Contact our Factbird support where we are happy to answer any questions',
                  })}
                  :
                </Typography>

                <Grid container style={{ margin: 1 / 2 }}>
                  <MailOutline />
                  <Typography style={{ marginLeft: theme.spacing() }}>support@factbird.com</Typography>
                </Grid>
                <Grid container style={{ margin: 1 / 2 }}>
                  <Phone />
                  <Typography style={{ marginLeft: theme.spacing() }}>+45 21 39 59 66</Typography>
                </Grid>

                <Typography variant="h5" style={{ marginTop: theme.spacing(3) }}>
                  3. {t(['shared:systemStatus'], { defaultValue: 'System status' })}
                </Typography>
                <Grid container>
                  <Typography>
                    {t(['shared:systemStatusExplanation1'], { defaultValue: 'Keep track of the' })}
                  </Typography>
                  <Typography
                    color="secondary"
                    style={{ marginLeft: theme.spacing(0.5), marginRight: theme.spacing(0.5) }}
                  >
                    <Link href="https://status.blackbird.online/" target="_blank">
                      {t(['shared:systemStatus'], { defaultValue: 'System status' })}
                    </Link>
                  </Typography>
                  <Typography>
                    {t(['shared:systemStatusExplanation2'], {
                      defaultValue:
                        'at all times at the bottom right corner of the page. Click on the link to see the full status and optionally subscribe to updates.',
                    })}
                  </Typography>
                </Grid>
                <img style={{ width: '300px' }} src="/images/system-status.png" />
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    );
  }
}
const enhance = compose<unknown, Properties>(withTranslation(['shared']), withStyles(styles, { withTheme: true }));
export default enhance(HelpPage as React.ComponentType<unknown>);
